import React from 'react'
import { useController } from 'react-hook-form'
import { HelperText } from './helperText'

export const TimePickerSelection = ({
  name,
  label,
  className,
  defaultValue = '08:00', // default value in 24-hour format
  control,
  disabled = false,
  labelStyle,
  updateStyle,
  onChangeOverride,
  onChange
}) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue
  })

  const handleChange = (e) => {
    if (typeof onChangeOverride === 'function') {
      onChangeOverride(e, field, fieldState)
    } else {
      onChange?.(e)
      field.onChange(e)
    }
  }

  return (
    <div className={className}>
      {label && (
        <label htmlFor={name} style={{ ...labelStyle }}>
          {label}
        </label>
      )}
      <input
        id={name}
        type="time"
        name={name}
        value={field.value}
        ref={field.ref}
        onChange={handleChange}
        onBlur={field.onBlur}
        disabled={disabled}
        style={{
          padding: '5px',
          border: disabled ? '1px solid grey' : '',
          ...updateStyle
        }}
      />
      <HelperText
        invalid={invalid}
        error={error}
        style={{ marginTop: '0px', height: '0px', color: 'red' }}
      />
    </div>
  )
}
